class TeaserWithImageTextAndButton {
  constructor() {
    this.init = this.init.bind(this);
    this.repositionTeaser = this.repositionTeaser.bind(this);
    this.init();
  }

  init() {
    const teaser = document.querySelector('.js-teaser-image-text-button');
    const headline1 = document.querySelector('h1');
    const marginalCol = document.querySelector('.js-marginal');

    if (teaser && headline1 && marginalCol) {
      this.repositionTeaser(teaser, headline1, marginalCol);

      window.addEventListener('resize', () => {
        this.repositionTeaser(teaser, headline1, marginalCol);
      });
    }
  }

  repositionTeaser(teaser, headline1, marginalCol) {
    if (window.screen.width < 1200) {
      headline1.after(teaser);
    } else {
      marginalCol.append(teaser);
    }
  }
}

export default new TeaserWithImageTextAndButton();
